import { gameState, config } from '@js/state';
import { enablePointerEvents, disablePointerEvents } from '@utils/pointer-events-control';

let spring1 = [];
let spring2 = [];
let graphics = null;
let graphics2 = null;
let graphics3 = null;
let graphics4 = null;
let reviveb = '';
let Buttons = [];
let N2 = null;
let D2 = null;
let Ttest = true;
let gameitems = 0;

export default class GameScene extends Phaser.Scene {
  constructor() {
    super({ key: 'GameScene' });
  }

  preload() {}

  create() {
    enablePointerEvents();

    if (gameState.retry == true) {
      spring2 = [];
      graphics = null;
      graphics2 = null;
      graphics3 = null;
      graphics4 = null;
      reviveb = '';
      Buttons = [];
      N2 = null;
      D2 = null;
      Ttest = true;
      gameitems = 0;
    }
    config.audio.bgaudio.setVolume(0.02);

    this.anims.create({
      key: 'sunrise',
      frames: this.anims.generateFrameNames('sunAnim', {
        start: 0,
        end: 348,
        zeroPad: 0,
        prefix: 'sunAnim',
        suffix: '.png',
      }),
      frameRate: 40,
      repeat: 0,
    });

    config.audio.sunShining.setVolume(0.05);

    this.sun = this.add.sprite(0, 0, 'sunAnim').setOrigin(0).setDepth(8);

    gameState.attempts = 0;
    spring1 = [];
    spring2 = [];
    Buttons = [];
    gameState.hneed = false;
    this.bg = this.add.image(0, 0, 'bg').setOrigin(0).setAlpha(0);

    gameitems = this.physics.add.group();

    this.Lboard = this.add.image(77.24, 325.33, 'Lboard').setOrigin(0).setDepth(1).setAlpha(0);

    this.Rstick = this.add.image(1056.66, 310.88, 'Rstick').setOrigin(0).setAlpha(0);
    this.Rbox = this.add
      .image(1065.66 + 123 / 2, 324.88 + 135 / 2, 'Rbox')
      .setOrigin(0.5)
      .setDepth(1)
      .setAlpha(0);

    this.slot = this.add
      .image(1109.65 - 3, 341, 'slot')
      .setOrigin(0)
      .setDepth(1)
      .setAlpha(0);

    this.slot2 = this.add
      .image(1102.96 - 3, 400, 'slot')
      .setOrigin(0)
      .setDepth(1)
      .setAlpha(0);

    this.N1 = this.add
      .text(174, 387, '5', { fontFamily: 'font1', fontSize: '40px', fill: '#000000' })
      .setAngle(-8)
      .setOrigin(0.5)
      .setDepth(1)
      .setAlpha(0);
    this.D1 = this.add
      .text(180, 438, '15', { fontFamily: 'font1', fontSize: '40px', fill: '#000000' })
      .setAngle(-8)
      .setOrigin(0.5)
      .setDepth(1)
      .setAlpha(0);

    if (
      gameState.level == 1 ||
      gameState.level == 2 ||
      gameState.level == 3 ||
      gameState.level == 4 ||
      gameState.level == 6 ||
      gameState.level == 10
    ) {
      N2 = this.add
        .text(1134.6, 370, '', { fontFamily: 'font1', fontSize: '40px', fill: '#000000' })
        .setAngle(6)
        .setOrigin(0.5)
        .setDepth(1)
        .setAlpha(0);

      D2 = this.add
        .text(1128, 425, '3', { fontFamily: 'font1', fontSize: '40px', fill: '#000000' })
        .setAngle(6)
        .setOrigin(0.5)
        .setDepth(1)
        .setAlpha(0);
    } else {
      N2 = this.add
        .text(1134.6, 366, '', { fontFamily: 'font1', fontSize: '40px', fill: '#000000' })
        .setAngle(6)
        .setOrigin(0.5)
        .setDepth(1)
        .setAlpha(0);

      D2 = this.add
        .text(1129, 421, '3', { fontFamily: 'font1', fontSize: '40px', fill: '#000000' })
        .setAngle(6)
        .setOrigin(0.5)
        .setDepth(1)
        .setAlpha(0);
    }

    this.Lbar = this.add.image(151.79, 406.53, 'Lbar').setOrigin(0).setDepth(1).setAlpha(0);
    this.Rbar = this.add.image(1105.45, 389, 'Rbar').setOrigin(0).setDepth(1).setAlpha(0);
    this.Rbar2 = this.add.image(1105.45, 389, 'Rbar').setOrigin(0).setDepth(1).setAlpha(0);

    this.wspring2 = this.add.image(889, 308, 'wspring').setOrigin(0).setDepth(1).setAlpha(0);
    this.wspring1 = this.add.image(385, 308, 'wspring').setOrigin(0).setDepth(1).setAlpha(0);

    this.lightpanel = this.add.image(487, 0, 'lightpanel').setOrigin(0).setAlpha(0);

    this.green = [];
    this.green.push(this.add.image(510, 30, 'green').setOrigin(0).setVisible(false).setAlpha(0));
    this.green.push(
      this.add.image(510 + 42, 30, 'green').setOrigin(0).setVisible(false).setAlpha(0),
    );
    this.green.push(
      this.add.image(510 + 84, 30, 'green').setOrigin(0).setVisible(false).setAlpha(0),
    );
    this.green.push(
      this.add.image(510 + 126, 30, 'green').setOrigin(0).setVisible(false).setAlpha(0),
    );
    this.green.push(
      this.add
        .image(510 + 126 + 40.98, 30, 'green')
        .setOrigin(0)
        .setVisible(false)
        .setAlpha(0),
    );
    this.green.push(
      this.add
        .image(510 + 126 + 40.98 + 41, 30, 'green')
        .setOrigin(0)
        .setVisible(false)
        .setAlpha(0),
    );

    for (let i = 0; i < gameState.correct; i++) {
      this.green[i].setVisible(true);
    }

    this.pad = this.add.image(873, 346, 'pad').setOrigin(0).setAlpha(0).setDepth(7);

    this.Bx = 887;
    this.By = 360;
    this.Bxgap = 48;
    this.Bygap = 56;

    Buttons.push(this.add.image(this.Bx, this.By + 3 * this.Bygap, '0_').setOrigin(0));

    Buttons.push(this.add.image(this.Bx, this.By, '1_').setOrigin(0));
    Buttons.push(this.add.image(this.Bx + this.Bxgap, this.By, '2_').setOrigin(0));
    Buttons.push(this.add.image(this.Bx + 2 * this.Bxgap, this.By, '3_').setOrigin(0));

    Buttons.push(this.add.image(this.Bx, this.By + this.Bygap, '4_').setOrigin(0));
    Buttons.push(this.add.image(this.Bx + this.Bxgap, this.By + this.Bygap, '5_').setOrigin(0));
    Buttons.push(this.add.image(this.Bx + 2 * this.Bxgap, this.By + this.Bygap, '6_').setOrigin(0));

    Buttons.push(this.add.image(this.Bx, this.By + 2 * this.Bygap, '7_').setOrigin(0));
    Buttons.push(
      this.add.image(this.Bx + this.Bxgap, this.By + 2 * this.Bygap, '8_').setOrigin(0),
    );
    Buttons.push(
      this.add.image(this.Bx + 2 * this.Bxgap, this.By + 2 * this.Bygap, '9_').setOrigin(0),
    );

    Buttons.push(this.add.image(this.Bx + this.Bxgap, this.By + 3 * this.Bygap, '10_').setOrigin(0));

    for (let i = 0; i < 11; i++) {
      Buttons[i].setInteractive({ cursor: 'pointer' }).setAlpha(0).setDepth(7);

      Buttons[i].on('pointerover', function () {
        this.setTexture(i + '_h');
      });
      Buttons[i].on('pointerout', function () {
        this.setTexture(i + '_');
      });

      if (i < 10) {
        Buttons[i].on('pointerdown', function () {
          this.setTexture(i + '_s');
          if (
            gameState.level == 1 ||
            gameState.level == 2 ||
            gameState.level == 3 ||
            gameState.level == 4 ||
            gameState.level == 6 ||
            gameState.level == 10
          ) {
            if (D2.text.length < 2 || D2.text == '') {
              D2.text = D2.text + i;
            }
          } else {
            if (N2.text.length < 2 || N2.text == '') {
              N2.text = N2.text + i;
            }
          }
        });
      } else {
        Buttons[i].on('pointerdown', function () {
          if (
            gameState.level == 1 ||
            gameState.level == 2 ||
            gameState.level == 3 ||
            gameState.level == 4 ||
            gameState.level == 6 ||
            gameState.level == 10
          ) {
            D2.text = '';
          } else {
            N2.text = '';
          }
        });
      }
    }

    this.check_button = this.add
      .image(559, 800, 'check_button')
      .setOrigin(0)
      .setInteractive({ cursor: 'pointer' });

    this.check_button.on('pointerover', () => {
      this.check_button.setTexture('check_h');
    });

    this.check_button.on('pointerout', () => {
      this.check_button.setTexture('check_button');
    });

    this.check_button.on('pointerdown', () => {
      gameState.clicked = true;

      if (gameState.level == 0) {
        this.overlay.setAlpha(0);
        this.carrow.setAlpha(0);
        this.Ttext4.setAlpha(0);
      }

      this.tweens.add({
        targets: this.check_button.disableInteractive(),
        y: 800,
        duration: 500,
        ease: 'Sine.easeInOut',
      });

      this.pad.setAlpha(0);

      for (let i = 0; i < 11; i++) {
        Buttons[i].setAlpha(0);
      }

      if (N2.text * this.D1.text == this.N1.text * D2.text) {
        config.audio.correctAnswer.play();

        this.green[gameState.correct].setVisible(true).setAlpha(1);

        gameState.correct++;

        if (
          gameState.level == 1 ||
          gameState.level == 2 ||
          gameState.level == 3 ||
          gameState.level == 4 ||
          gameState.level == 6 ||
          gameState.level == 10
        ) {
          D2.setColor('#149A53');
          this.slot2.setTexture('slot_c');
        } else {
          N2.setColor('#149A53');
          this.slot.setTexture('slot_c');
        }

        this.Garden2lines(this.D1.text, 1);
        this.Garden2lines(D2.text, 2);

        this.waterdelay = Math.ceil(36 * (this.N1.text / this.D1.text)) * 100;

        for (let i = Math.ceil(36 - 36 * (this.N1.text / this.D1.text)); i < 36; i++) {
          this.waterSprinke(
            spring2[i].play('water'),
            2000 + 100 * (i - (360 - 360 * (this.N1.text / this.D1.text)) / 10),
          );
          this.waterSprinke(
            spring1[i].play('water'),
            2000 + 100 * (i - (360 - 360 * (this.N1.text / this.D1.text)) / 10),
          );
        }

        this.time.delayedCall(2200 + 500, () => {
          config.audio.watering.play();
        });

        this.arcs();

        this.tweens.add({
          targets: [graphics, graphics2],
          alpha: 1,
          duration: 2000,
          delay: 2500 + this.waterdelay + 500,
          ease: 'Sine.easeInOut',
          onComplete: () => {
            config.audio.watering.stop();

            config.audio.sunShining.play();

            this.tweens.add({
              targets: config.audio.sunShining,
              volume: 0.005,
              duration: 3000,
            });

            this.sun.play('sunrise');

            this.time.delayedCall(3000 + 500, () => {
              config.audio.sunShining.stop();
              config.audio.flowerBlossoming.play();
            });
          },
        });

        this.tweens.add({
          targets: [graphics, graphics2],
          alpha: 0,
          duration: 2000,
          delay: 3000 + 5700 + this.waterdelay + 500,
          ease: 'Sine.easeInOut',
        });

        this.tweens.add({
          targets: [graphics3, graphics4],
          alpha: 1,
          duration: 2000,
          delay: 3000 + 5700 + this.waterdelay + 500,
          ease: 'Sine.easeInOut',

          onStart: () => {
            this.dangle = (360 * (this.N1.text / this.D1.text)) / 8;

            this.time.delayedCall(200, () => {
              this.flowerGenerator(360 * (this.N1.text / this.D1.text) - 5, this.dangle);
            });

            this.time.delayedCall(400, () => {
              this.flowerGenerator(
                360 * (this.N1.text / this.D1.text) - 5 - this.dangle,
                this.dangle,
              );
            });

            this.time.delayedCall(600, () => {
              this.flowerGenerator(
                360 * (this.N1.text / this.D1.text) - 5 - 2 * this.dangle,
                this.dangle,
              );
            });

            this.time.delayedCall(800, () => {
              this.flowerGenerator(
                360 * (this.N1.text / this.D1.text) - 5 - 3 * this.dangle,
                this.dangle,
              );
            });

            this.time.delayedCall(1000, () => {
              this.flowerGenerator(
                360 * (this.N1.text / this.D1.text) - 5 - 4 * this.dangle,
                this.dangle,
              );
            });

            this.time.delayedCall(1200, () => {
              this.flowerGenerator(
                360 * (this.N1.text / this.D1.text) - 5 - 5 * this.dangle,
                this.dangle,
              );
            });

            this.time.delayedCall(1400, () => {
              this.flowerGenerator(
                360 * (this.N1.text / this.D1.text) - 5 - 6 * this.dangle,
                this.dangle,
              );
            });

            this.time.delayedCall(1400, () => {
              this.flowerGenerator(5 + this.dangle, this.dangle);
            });

            this.time.delayedCall(3700, () => {
              gameState.level++;

              if (gameState.correct == 6) {
                gameState.gameWin = true;
                gameState.cam = this.cameras.main;
                disablePointerEvents();
                this.scene.launch('EndScene');
                this.scene.pause('GameScene');
              } else if (gameState.level >= 11) {
                gameState.gameWin = false;
                gameState.cam = this.cameras.main;
                disablePointerEvents();
                this.scene.launch('EndScene');
                this.scene.pause('GameScene');
              } else {
                const r5 = this.add
                  .rectangle(0, 0, 1280, 720, 0xffffff)
                  .setOrigin(0)
                  .setDepth(10)
                  .setAlpha(0);
                this.tweens.add({
                  targets: r5,
                  alpha: 1,
                  duration: 500,
                  ease: 'Sine.easeInOut',
                  onComplete: () => {
                    this.scene.restart('GameScene');
                  },
                });
              }
            });
          },
        });
      } else {
        config.audio.wrongAnswer.play();
        gameState.attempts++;
        this.Rbox.setTexture('Rbox_w');
        this.Rstick.setTexture('Rstick_w');
        this.Rbar.setTexture('Rbar_w');
        this.Rbar2.setTexture('Rbar_w');

        D2.setColor('#C22300');
        N2.setColor('#C22300');
        this.slot.setTexture('slot_w');
        this.slot2.setTexture('slot_w');

        this.tweens.add({
          targets: this.Rbox,
          delay: 100,
          duration: 200,
          ease: 'Sine.easeInOut',
          angle: {
            getEnd: () => -3,
            getStart: () => 3,
          },
          yoyo: true,
          repeat: 1,
          onComplete: () => {
            if (gameState.attempts >= 3) {
              gameState.level++;
              if (gameState.level >= 11) {
                gameState.gameWin = false;
                gameState.cam = this.cameras.main;
                disablePointerEvents();
                this.scene.launch('EndScene');
                this.scene.pause('GameScene');
              } else {
                this.scene.restart('GameScene');
              }
            } else {
              this.Rbox.setTexture('Rbox').setAngle(0);
              D2.setColor('#00000');
              N2.setColor('#000000');
              this.slot.setTexture('slot');
              this.slot2.setTexture('slot');

              this.Rbar.setTexture('Rbar');
              this.Rbar2.setTexture('Rbar');
              this.Rstick.setTexture('Rstick');

              if (
                gameState.level == 1 ||
                gameState.level == 2 ||
                gameState.level == 3 ||
                gameState.level == 4 ||
                gameState.level == 6 ||
                gameState.level == 10
              ) {
                D2.text = '';
              } else {
                N2.text = '';
              }

              this.pad.setAlpha(1);

              this.tweens.add({
                targets: this.check_button,
                y: 584,
                duration: 500,
                delay: 500,
                ease: 'Sine.easeInOut',
                onComplete: () => {
                  this.check_button.setInteractive();
                },
              });

              gameState.hneed = true;

              for (let i = 0; i < 11; i++) {
                Buttons[i].setAlpha(1);
              }
            }
          },
        });
      }
    });

    for (let i = 0; i < 36; i++) {
      spring1.push(
        this.add
          .sprite(385 + 23.22, 308 + 23.22, 'sprinkleWaterAnim')
          .setScale(0)
          .setOrigin((385 + 23.22) / 1280, (308 + 23.22) / 720)
          .setAngle(i * 10 - 265),
      );
      spring2.push(
        this.add
          .sprite(889 + 23.22, 308 + 23.22, 'sprinkleWaterAnim')
          .setScale(0)
          .setOrigin((385 + 23.22) / 1280, (308 + 23.22) / 720)
          .setAngle(i * 10 - 265),
      );
    }

    this.anims.create({
      key: 'water',
      frames: this.anims.generateFrameNames('sprinkleWaterAnim', {
        start: 0,
        end: 30,
        prefix: 'SprinkleAnim',
        suffix: '.png',
      }),
      frameRate: 20,
      repeat: 5,
    });

    this.gameStart();
  }

  flowerGenerator(maxAngle, dangle) {
    let timedelay = 0;

    for (let i = 0; i < 4 * Math.ceil(dangle); i++) {
      timedelay = timedelay + 200 / (4 * Math.ceil(dangle));
      this.time.delayedCall(timedelay, () => {
        const radi = Phaser.Math.RND.between(27, 200);
        const angi = Phaser.Math.RND.between(270 - maxAngle, 270 - maxAngle + dangle);
        const x = 385 + 23.22 + radi * Math.cos((angi * Math.PI) / 180);
        const y = 308 + 23.22 + radi * Math.sin((angi * Math.PI) / 180);

        let newobj;
        let newobj2;
        if (i % 2 == 1) {
          newobj = gameitems.create(x, y, 'flower').setAlpha(0).setScale(0.2);
          newobj2 = gameitems.create(x - 385 + 889, y, 'flower').setAlpha(0).setScale(0.2);
        } else {
          newobj = gameitems.create(x, y, 'flower2').setAlpha(0).setScale(0.2);
          newobj2 = gameitems.create(x - 385 + 889, y, 'flower2').setAlpha(0).setScale(0.2);
        }
        this.tweens.add({
          targets: [newobj, newobj2],
          duration: 200,
          alpha: 1,
          scale: 1,
          ease: 'Sine.easeInOut',
        });
      });
    }
  }

  arcs() {
    graphics = this.add.graphics();
    graphics.fillStyle(0x2b2b2b, 0.5);
    graphics.slice(
      385 + 23.22,
      308 + 23.22,
      210,
      Phaser.Math.DegToRad(270),
      Phaser.Math.DegToRad(270 - 360 * (this.N1.text / this.D1.text)),
      true,
    );
    graphics.fillPath().setAlpha(0);

    graphics2 = this.add.graphics();
    graphics2.fillStyle(0x2b2b2b, 0.5);
    graphics2.slice(
      889 + 23.22,
      308 + 23.22,
      210,
      Phaser.Math.DegToRad(270),
      Phaser.Math.DegToRad(270 - 360 * (this.N1.text / this.D1.text)),
      true,
    );
    graphics2.fillPath().setAlpha(0);

    graphics3 = this.add.graphics();
    graphics3.fillStyle(0x005e2c, 1);
    graphics3.slice(
      385 + 23.22,
      308 + 23.22,
      210,
      Phaser.Math.DegToRad(270),
      Phaser.Math.DegToRad(270 - 360 * (this.N1.text / this.D1.text)),
      true,
    );
    graphics3.fillPath().setAlpha(0);

    graphics4 = this.add.graphics();
    graphics4.fillStyle(0x005e2c, 1);
    graphics4.slice(
      889 + 23.22,
      308 + 23.22,
      210,
      Phaser.Math.DegToRad(270),
      Phaser.Math.DegToRad(270 - 360 * (this.N1.text / this.D1.text)),
      true,
    );
    graphics4.fillPath().setAlpha(0);
  }

  waterSprinke(items, delayed) {
    this.tweens.add({
      targets: items,
      scale: 1,
      duration: 1000,
      delay: delayed,
      ease: 'Sine.easeInOut',
      onComplete: () => {
        this.tweens.add({
          targets: items,
          scale: 0,
          delay: 2000,
          duration: 1000,
          ease: 'Sine.easeInOut',
        });
      },
    });
  }

  Garden2lines(j, garden) {
    this.line2delay = 0;
    this.lineduration = 1500;

    for (let i = 0; i < j; i++) {
      let r1;
      if (garden == 2) {
        r1 = this.add
          .line(889 + 23.22, 308 + 23.22, 0, -108, 0, 100, 0xffcf56)
          .setScale(0)
          .setAngle((i * 360) / j);
      } else {
        r1 = this.add
          .line(385 + 23.22, 308 + 23.22, 0, -108, 0, 100, 0xffcf56)
          .setScale(0)
          .setAngle((i * 360) / j);
      }
      this.line2delay = i * (this.lineduration / j);

      this.tweens.add({
        targets: r1,
        scale: 1,
        delay: this.line2delay,
        duration: 500,
        ease: 'Sine.easeInOut',
      });
    }
  }

  gameStart() {
    if (gameState.level == 0) {
      this.overlay = this.add.image(0, 0, 'overlay').setOrigin(0).setDepth(5);
      this.Ttext = this.add.image(358, 334, 'Ttext1').setOrigin(0).setDepth(5);

      this.check_button.disableInteractive();
      this.tweens.add({
        targets: [
          this.bg,
          this.wspring1,
          this.wspring2,
          this.Lbar,
          this.Lboard,
          this.Rbar,
          this.Rbox,
          this.Rstick,
          this.D1,
          D2,
          this.N1,
          N2,
          this.slot,
          this.lightpanel,
        ],
        alpha: 1,
        duration: 500,
        delay: 0,
        ease: 'Sine.easeInOut',

        onStart: () => {
          this.time.delayedCall(500, () => {
            config.audio.ta1.play();
          });
        },
        onComplete: () => {
          this.time.delayedCall(2400, () => {
            this.Ttext.setAlpha(0);
          });
        },
      });

      this.tweens.add({
        targets: this.Ttext,
        alpha: 1,
        duration: 500,
        delay: 3000,
        ease: 'Sine.easeInOut',
        onStart: () => {
          this.Lbar.setDepth(6);
          this.Lboard.setDepth(6);
          this.Rbar.setDepth(6);
          this.Rbox.setDepth(6);
          this.Rstick.setDepth(6);
          this.D1.setDepth(6);
          D2.setDepth(6);
          this.N1.setDepth(6);
          N2.setDepth(6);
          this.slot.setDepth(6);

          this.Ttext.setTexture('Ttext2');
          this.time.delayedCall(500, () => {
            config.audio.ta2.play();
          });
        },
        onComplete: () => {
          this.time.delayedCall(3400, () => {
            this.Ttext.setAlpha(0);
          });
        },
      });

      this.tweens.add({
        targets: [
          this.Ttext,
          this.pad,
          Buttons[0],
          Buttons[1],
          Buttons[2],
          Buttons[3],
          Buttons[4],
          Buttons[5],
          Buttons[6],
          Buttons[7],
          Buttons[8],
          Buttons[9],
          Buttons[10],
        ],
        alpha: 1,
        duration: 500,
        delay: 7000,
        ease: 'Sine.easeInOut',
        onStart: () => {
          this.Ttext.setTexture('Ttext3');
          this.Ttext.x = 225;
          this.Ttext.y = 243;
        },
        onComplete: () => {
          this.tweens.add({
            targets: this.check_button.disableInteractive(),
            y: 584,
            duration: 500,
            ease: 'Sine.easeInOut',
          });

          this.time.delayedCall(500, () => {
            config.audio.ta3.play();
          });

          this.parrow = this.add.image(757, 320, 'parrow').setOrigin(0).setDepth(7);

          this.tweens.add({
            targets: this.parrow,
            x: { getEnd: () => 787, getStart: () => 757 },
            y: { getEnd: () => 345, getStart: () => 320 },
            duration: 500,
            delay: 100,
            yoyo: true,
            repeat: -1,
            ease: 'Sine.easeInOut',
          });
        },
      });
    } else {
      if (gameState.level == 1) {
        this.N1.text = 2;
        this.D1.text = 7;
        N2.text = 8;
        D2.text = '';
      } else if (gameState.level == 2) {
        this.N1.text = 9;
        this.D1.text = 12;
        N2.text = 3;
        D2.text = '';
      } else if (gameState.level == 3) {
        this.N1.text = 5;
        this.D1.text = 15;
        N2.text = 1;
        D2.text = '';
      } else if (gameState.level == 4) {
        this.N1.text = 8;
        this.D1.text = 16;
        N2.text = 4;
        D2.text = '';
      } else if (gameState.level == 5) {
        this.N1.text = 4;
        this.D1.text = 20;
        N2.text = '';
        D2.text = 5;
      } else if (gameState.level == 6) {
        this.N1.text = 4;
        this.D1.text = 8;
        N2.text = 3;
        D2.text = '';
      } else if (gameState.level == 7) {
        this.N1.text = 10;
        this.D1.text = 12;
        N2.text = '';
        D2.text = 18;
      } else if (gameState.level == 8) {
        this.N1.text = 2;
        this.D1.text = 6;
        N2.text = '';
        D2.text = 9;
      } else if (gameState.level == 9) {
        this.N1.text = 12;
        this.D1.text = 21;
        N2.text = '';
        D2.text = 14;
      } else if (gameState.level == 10) {
        this.N1.text = 6;
        this.D1.text = 10;
        N2.text = 9;
        D2.text = '';
      }

      this.tweens.add({
        targets: [
          this.green[0],
          this.green[1],
          this.green[2],
          this.green[3],
          this.green[4],
          this.green[5],
          this.bg,
          this.wspring1,
          this.wspring2,
          this.Lbar,
          this.Lboard,
          this.Rbox,
          this.Rstick,
          this.D1,
          D2,
          this.N1,
          N2,
          this.lightpanel,
        ],
        alpha: { getEnd: () => 1, getStart: () => 0 },
        duration: 500,
        delay: 0,
        ease: 'Sine.easeInOut',
      });

      this.tweens.add({
        targets: () => {
          if (
            gameState.level == 1 ||
            gameState.level == 2 ||
            gameState.level == 3 ||
            gameState.level == 4 ||
            gameState.level == 6 ||
            gameState.level == 10
          ) {
            return [this.slot2, this.Rbar2];
          } else {
            return [this.slot, this.Rbar];
          }
        },
        alpha: { getEnd: () => 1, getStart: () => 0 },
        duration: 500,
        delay: 0,
        ease: 'Sine.easeInOut',
      });

      this.tweens.add({
        targets: [
          this.pad,
          Buttons[0],
          Buttons[1],
          Buttons[2],
          Buttons[3],
          Buttons[4],
          Buttons[5],
          Buttons[6],
          Buttons[7],
          Buttons[8],
          Buttons[9],
          Buttons[10],
        ],
        alpha: 1,
        duration: 500,
        delay: 1000,
        ease: 'Sine.easeInOut',
        onComplete: () => {
          this.tweens.add({
            targets: this.check_button.setInteractive(),
            y: 584,
            duration: 500,
            ease: 'Sine.easeInOut',
          });
        },
      });
    }
  }

  update() {
    if (gameState.level == 0 && N2.text == '1' && Ttest) {
      Ttest = false;
      this.check_button.setDepth(7).setInteractive();

      this.Ttext.setAlpha(0);
      this.parrow.setAlpha(0);

      this.Ttext4 = this.add.image(835, 599, 'Ttext4').setOrigin(0).setDepth(7).setAlpha(0);

      this.pad.setAlpha(0);

      for (let i = 0; i < 11; i++) {
        Buttons[i].setAlpha(0);
      }
      this.tweens.add({
        targets: this.Ttext4,
        alpha: 1,
        duration: 500,
        delay: 100,
        ease: 'Sine.easeInOut',
        onComplete: () => {
          config.audio.ta4.play();
          this.carrow = this.add.image(775, 590, 'carrow').setOrigin(0).setDepth(7);
          this.tweens.add({
            targets: this.carrow,
            x: { getEnd: () => 760, getStart: () => 775 },
            duration: 500,
            delay: 100,
            yoyo: true,
            repeat: -1,
            ease: 'Sine.easeInOut',
          });
        },
      });
    }

    if (reviveb !== '') {
      Buttons[reviveb].setTexture(reviveb + '_');
      reviveb = '';
    }
  }
}
